import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { HttpService } from "src/app/wrappers/Http";
import { ConfigService } from "../config.service";
import { GoalJackpot, GoalPackage, WinningRule, GoalType, GoalObj, GoalEvent } from "src/app/interface/goal-config";

@Injectable({
  providedIn: "root",
})
export class GoalManagementService {
  private _goalMarkets: Array<any> = new Array(0);
  private _winningRules: Array<any> = new Array(0);
  private _goalItems: Array<any> = new Array(0);
  private _goalJackpots: Array<GoalJackpot> = new Array(0);
  private _goalPackages: Array<GoalPackage> = new Array(0);
  private _goalRules: Array<WinningRule> = new Array(0);
  private _goalTypes: Array<GoalType> = new Array(0);
  private _goalDistroTypes = new Array(0);
  private _goalObjs: Array<GoalObj> = new Array(0);
  private _goalEvts: Array<GoalEvent> = new Array(0);
  goalRapport: any = {};

  constructor(
    private httpService: HttpService,
    private translate: TranslateService,
    private configService: ConfigService,
    private messageServrice: MessageService
  ) {}

  public get goalItems(): Array<any> {
    return this._goalItems;
  }
  public set goalItems(value: Array<any>) {
    this._goalItems = value;
  }

  public get winningRules(): Array<any> {
    return this._winningRules;
  }
  public set winningRules(value: Array<any>) {
    this._winningRules = value;
  }

  public get goalMarkets(): Array<any> {
    return this._goalMarkets;
  }
  public set goalMarkets(value: Array<any>) {
    this._goalMarkets = value;
  }

  public get goalEvts(): Array<GoalEvent> {
    return this._goalEvts;
  }
  public set goalEvts(value: Array<GoalEvent>) {
    this._goalEvts = value;
  }

  public get goalObjs(): Array<GoalObj> {
    return this._goalObjs;
  }
  public set goalObjs(value: Array<GoalObj>) {
    this._goalObjs = value;
  }

  public get goalJackpots(): Array<GoalJackpot> {
    return this._goalJackpots;
  }
  public set goalJackpots(value: Array<GoalJackpot>) {
    this._goalJackpots = value;
  }
  public get goalPackages(): Array<GoalPackage> {
    return this._goalPackages;
  }
  public set goalPackages(value: Array<GoalPackage>) {
    this._goalPackages = value;
  }
  public get goalRules(): Array<WinningRule> {
    return this._goalRules;
  }
  public set goalRules(value: Array<WinningRule>) {
    this._goalRules = value;
  }
  public get goalDistroTypes(): Array<any> {
    return this._goalDistroTypes;
  }
  public set goalDistroTypes(value: Array<any>) {
    this._goalDistroTypes = value;
  }
  public get goalTypes(): Array<GoalType> {
    return this._goalTypes;
  }
  public set goalTypes(value: Array<GoalType>) {
    this._goalTypes = value;
  }

  addGoalJackpot(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.newJackpot, params);
  }
  addGoalType(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.newGoalType, params);
  }
  addGoalWinningRule(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.newWinningRule, params);
  }
  addGoalWinningRuleItem(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.newWinningRuleItem, params);
  }
  editJackpot(params: any): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateJackpot, params);
  }

  addGoalPackage(params): Promise<any> {
    // this.configService.GATEWAY_ADMIN
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.newGoalPackage, params);
  }

  editGoalType(params: any): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateGoalType, params);
  }
  editGoalWinningRule(params: any): Promise<any> {
   return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateWinningRule, params);
  }
  editGoalWinningRuleItem(params: any): Promise<any> {
   return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateWinningRuleItem, params);
  }
  editGoalPackage(params: any): Promise<any> {
    // tslint:disable-next-line: max-line-length
    // this.configService.PROXIES.sport_admin_services
    return this.httpService.PUT_NO_AUTH(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.updateGoalPackage, params);
  }

  addGoalItem(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.newGoalObj, params);
  }
  updateGoalItem(params): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateGoal, params);
  }

  assignEventsToGoal(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.assignGoalEvents, params);
  }
  UnassignEventsToGoal(params): Promise<any> {
    return this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.unassignGoalEvents, params);
  }

  loadGoalJackpots(params, more) {
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allJackpotConfigs, params, true)
      .then(res => {
      if (res.hasOwnProperty('erc') && res.erc == '1')
        this.goalJackpots = (more === 'load-more') ? [...this.goalJackpots, ...res.data] : res.data;

        console.log("goal jackpots", this.goalJackpots);
    })
  }

  loadGoalDistributions(params){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
       this.configService.GOAL_CONFIGS.goalDistributionTypes, params, true).then(res => {
        if (res.hasOwnProperty('erc') && res.erc == '1')
          this.goalDistroTypes = res.data;

          console.log("goalDistroTypes", this.goalDistroTypes);
       })
  }

  loadGoalTypes(params = {}) {
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.allGoalTypes, params, true)
    .then( res=> {
      if (res.hasOwnProperty('erc') && res.erc == '1')
          this.goalTypes = res.data;

          // console.log("goalTypes", this.goalTypes);
       })
  }
  getGoalType(params?:any) {
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allGoalTypes, params, true)
    // return this.httpService.get_no_auth(this.configService.GATEWAY_ADMIN_  + this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.allGoalTypes, params)
  }

  loadGoalWinningRules(params) {
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allGoalRules, params, true)
    .then((res)=> {
      if (res.hasOwnProperty('erc') && res.erc == '1')
          this.winningRules = res.data;
          console.log('winning rules:', this.winningRules);

       })
    //this.configService.GATEWAY_ADMIN_  + this.configService.ServiceUrls.goal_admin_services
  }

  loadGoalWinningRuleItems(params, id?) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
      this.configService.GOAL_CONFIGS.winningRuleItems, params, true)
  }

  loadGoalPackages(params?: any) {
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allGoalPackages, params, true)
  }

  loadGoalMarkets(params){
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.goalMarkets, params, true)
    .then((res)=> {
      if (res.hasOwnProperty('erc') && res.erc == '1')
          this.goalMarkets = res.data;
       })
  }

  assignGoalType(params){
    return  this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.assignGoalType, params);
  }

  assignWinningRule(params){
    return  this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_,this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.assignRule, params);
  }

  assignChannels(params){
    return  this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.assignGoalChannels, params);
  }

  loadGoals(params){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allGoals, params, true)
    .then((res)=> {
      if (res.hasOwnProperty('erc') && res.erc == '1')
          this.goalItems = res.data;
       })
  }

  loadGoalRapport(id){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,  this.configService.GOAL_CONFIGS.rapportGoal + '/' + id, {}, true)
    .then((res)=> {
      if (res.hasOwnProperty('erc') && res.erc == '1')
          this.goalRapport = res.data;
       })
  }

  loadGoalEvents(params,id){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.getGoalEvents + id + '/events', params, true)
  }
    loadGoalDetails(params){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.goalDetails, params, true)
  }

  validateGoal(params): Promise<any> {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, + this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.validateGoal, params, true);
  }

  cancelGoal(params,id){
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.cancelGoal + id + '/cancel', params);
  }
  confirmCancelGoal(params,id){
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.cancelGoal + id + '/confirm-cancel', params);
  }
  reinitialiseGoal(params,id){
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.cancelGoal + id + '/reinitialise', params);
  }
  settlementGoal(params){
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.settleGoal, params);
  }
  rollbackCancelGoal(params,id){
    // return  this.httpService.PostAuthParams('http://10.12.1.75:8010' + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelGoal + id + '/rollback/cancel', params);
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_, this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.cancelGoal + id + '/rollback/cancel', params);
  }


}
